<template>
  <a-config-provider :locale="zhCN">
    <router-view />
  </a-config-provider>
</template>
<script>
import { setTheme } from "@/theme";
import { defineComponent, onMounted } from "vue";
import { ConfigProvider } from "ant-design-vue";
import zhCN from "ant-design-vue/es/locale/zh_CN";
import { useStore } from "vuex";
// import { useRouter } from "vue-router";

export default defineComponent({
  components: {
    AConfigProvider: ConfigProvider
  },
  setup() {
    const store = useStore();
    onMounted(() => {
      //初始化主题
      setTheme(localStorage.getItem("tsl-theme-vue3") || "default");
    });
    return {
      zhCN,
      store
    };
  }
});
</script>

<!-- <style lang="less"></style> -->
